import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { realEstateAdminId: String, conversationAgentId: String, mode: String }
  static targets = ['templatesList']

  connect() {
    this.selectedTemplate = null
    this.selectedTemplateData = null
    this.templatesLoaded = false

    // Load templates when controller connects (modal is opened)
    setTimeout(() => {
      if (!this.templatesLoaded) {
        this.loadAllTemplateDetails()
      }
    }, 100)
  }

  closeModal() {
    // Find the modal element that contains this controller
    const modal = this.element.closest('dialog')
    if (modal) {
      modal.close()
      // Reset selection when closing modal
      this.selectedTemplate = null
      this.resetTemplateSelection()
    }
  }

  selectTemplate(event) {
    // Remove selection from all templates
    const allTemplates = document.querySelectorAll('.template-option')
    allTemplates.forEach((template) => {
      template.classList.remove('bg-blue-50', 'border-blue-300')
      const radio = template.querySelector('input[type="radio"]')
      if (radio) radio.checked = false
    })

    // Add selection to clicked template
    const selectedTemplate = event.currentTarget
    selectedTemplate.classList.add('bg-blue-50', 'border-blue-300')

    // Check the radio button
    const radio = selectedTemplate.querySelector('input[type="radio"]')
    if (radio) {
      radio.checked = true
      this.selectedTemplate = radio.value
    }
  }

  resetTemplateSelection() {
    const allTemplates = document.querySelectorAll('.template-option')
    allTemplates.forEach((template) => {
      template.classList.remove('bg-blue-50', 'border-blue-300')
      const radio = template.querySelector('input[type="radio"]')
      if (radio) radio.checked = false
    })
  }

  continueToParameters() {
    if (!this.selectedTemplate) {
      alert('Por favor, selecione um template antes de continuar.')
      return
    }

    // Show loading state
    const continueButton = document.querySelector(
      '[data-action="click->template-selector#continueToParameters"]'
    )
    const originalText = continueButton.textContent
    continueButton.textContent = 'Carregando...'
    continueButton.disabled = true

    // Fetch template details from Meta API
    this.fetchTemplateDetails(this.selectedTemplate)
      .then((templateData) => {
        // Reset button state
        continueButton.textContent = originalText
        continueButton.disabled = false

        if (templateData.success && templateData.template) {
          // Store the selected template ID before closing modal
          const selectedTemplateId = this.selectedTemplate

          // Close first modal
          this.closeModal()

          // Open parameters modal with template data
          this.openParametersModal(templateData.template, selectedTemplateId, this.modeValue)
        } else {
          console.error('Template data invalid:', templateData)
          alert('Erro ao carregar dados do template.')
        }
      })
      .catch((error) => {
        console.error('=== ERROR FETCHING TEMPLATE ===')
        console.error('Error:', error)

        // Reset button state
        continueButton.textContent = originalText
        continueButton.disabled = false

        alert('Erro ao carregar template. Tente novamente.')
      })
  }

  openParametersModal(templateData, selectedTemplateId, mode) {
    // Store template data in a global way for the parameters controller
    window.selectedTemplateData = {
      id: selectedTemplateId,
      data: templateData,
    }

    // Get the correct modal based on mode
    const modal =
      mode === 'resume'
        ? document.getElementById('resume_template_parameters_modal')
        : document.getElementById('template_parameters_modal')

    // Open the parameters modal
    if (modal) {
      modal.showModal()

      // Trigger setup of parameters modal
      const event = new CustomEvent('template-selected', {
        detail: { templateData: templateData, templateId: selectedTemplateId },
      })
      modal.dispatchEvent(event)
    } else {
      console.error('Modal not found for mode:', mode)
    }
  }

  async loadAllTemplateDetails() {
    const templateOptions = document.querySelectorAll('.template-option')

    for (const templateOption of templateOptions) {
      const templateId = templateOption.dataset.templateId
      const nameElement = templateOption.querySelector('.template-name')
      const bodyElement = templateOption.querySelector('.template-body')

      try {
        const templateData = await this.fetchTemplateDetails(templateId)

        if (templateData.success && templateData.template) {
          // Update the template name
          let template_name = templateData.template.name
          if (template_name == 'restart_support_conversation') {
            template_name = 'Reiniciar Conversa de Suporte'
          }
          if (template_name == 'init_new_support_conversation') {
            template_name = 'Iniciar Conversa de Suporte'
          }

          nameElement.textContent = template_name

          // Find the body component and extract text
          let bodyText = 'Sem texto disponível'
          if (templateData.template.components) {
            const bodyComponent = templateData.template.components.find(
              (comp) => comp.type === 'BODY'
            )
            if (bodyComponent && bodyComponent.text) {
              bodyText = bodyComponent.text
              // Truncate if too long
              if (bodyText.length > 100) {
                bodyText = bodyText.substring(0, 100) + '...'
              }
            }
          }

          bodyElement.textContent = bodyText
          bodyElement.classList.remove('text-gray-600')
          bodyElement.classList.add('text-gray-700')
        } else {
          nameElement.textContent = templateId
          bodyElement.textContent = 'Erro ao carregar template'
          bodyElement.classList.add('text-red-600')
        }
      } catch (error) {
        console.error('Error loading template:', templateId, error)
        nameElement.textContent = templateId
        bodyElement.textContent = 'Erro de conexão'
        bodyElement.classList.add('text-red-600')
      }
    }

    this.templatesLoaded = true
  }

  async fetchTemplateDetails(templateId) {
    try {
      // Use the real estate admin ID from data attribute
      if (!this.realEstateAdminIdValue) {
        throw new Error('Real Estate Admin ID not available')
      }

      if (!this.conversationAgentIdValue) {
        throw new Error('Conversation Agent ID not available')
      }

      const response = await fetch(
        `/real_estate_admin/${this.realEstateAdminIdValue}/whatsapp_templates/template_details`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').getAttribute('content'),
          },
          body: JSON.stringify({
            template_id: templateId,
            conversation_agent_id: this.conversationAgentIdValue,
          }),
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      return await response.json()
    } catch (error) {
      console.error('Fetch error:', error)
      throw error
    }
  }
}
